<template>
    <div class="sports_item_detail sports_register_detail">
      <img v-if="item_sub_id==2548" class="not" src="https://oss.mcloud.moveclub.cn/mpms/20210628/1624875148-60d9a08c441d3.png" alt="">
      <Form :list="itemDetail.registerform" :team="teamform" :buttonColor="buttonColor" @submit="submit" :statement="itemDetail.statement"/>
      <div class="sese" v-if="item_sub_id == 2591 || item_sub_id == 2592 || item_sub_id == 2593 || item_sub_id == 2594 || item_sub_id == 2595">请参照示范视频角度及动作，正面/侧面拍摄动作，保证动作标准性，以便系统识别计分，谢谢</div>
    </div>
</template>

<script>
    import Footbar from '@/components/footbar/index'
    import Form from '@/components/form/index.vue'

    import {Empty, Panel, Cell, Button, CellGroup} from 'vant';
    import "./index.less"
    const normalizeLabel = (label) => {
        if (!label) return '';
        return label.replace(/\s+/g, '')
                    .replace(/[:：]/g, '')
                    .replace(/号码/g, '')
                    .replace(/您的/g, '')
                    .replace(/联系/g, '')
                    .replace(/（用于领奖）/g, '')
                    .replace(/\(用于领奖\)/g, '');
    };

    export default {
        computed: {
            buttonColor() {
                let detail = this.detail;
                if (!detail) return '#ccc';
                return `${detail.tabstyle[0]['color']}`;
            }
        },
        components: {
            Empty,
            Panel,
            Cell,
            Button,
            CellGroup,
            Footbar,
            Form
        },
        props: ['item_sub_id', 'sports_id', 'signtype'],
        data() {
            return {
                detail: '',
                itemDetail: "",
                joinList: [],
                teamform: [],
                hiddenFields: []
            }
        },
        methods: {
            submit: function (e) {
                this.$dialog.confirm({
                    title: "提示",
                    confirmButtonText: '确定提交',
                    message: '信息提交后不可修改,确定提交?',
                    showCancelButton: true
                }).then(() => {
                    let finalFields = [...e];
                    if (this.hiddenFields && this.hiddenFields.length > 0) {
                        finalFields = finalFields.concat(this.hiddenFields);
                    }

                    this.$api.sports.submitCompare({cpgid: this.item_sub_id, registerInfo: finalFields}).then((res) => {
                        if (+res.status === 200) {
                          if(this.item_sub_id == 2591||this.item_sub_id == 2592||this.item_sub_id == 2593||this.item_sub_id == 2594||this.item_sub_id == 2595){
                            this.$router.replace({ name: 'sportsQues', params: { acid: 972 }})
                          }else if (+this.itemDetail.type === 5) {
                            this.$router.replace({ name: 'sportsQues', params: { acid: this.itemDetail.activity_id } })
                          }else{
                            this.$router.replace({ name: 'sportsResult', params:this.$route.params})
                          }

                        }
                    })

                    // on confirm
                }).catch(() => {
                    // on cancel
                });


                console.log(e)
            },
            init: function () {
                this.$toast.loading({
                    duration: 0
                });
                let params = {cpgid: this.item_sub_id}
                Promise.all([this.$api.sports.sportsMain(this.sports_id), this.$api.sports.getComparegame(params)]).then((res) => {
                    let {bgstyle, id, tabstyle, introstyle, title, register_mode, is_registered, registered_info} = res[0].data;
                    try {
                        bgstyle = JSON.parse(bgstyle)
                        tabstyle = JSON.parse(tabstyle)
                        introstyle = JSON.parse(introstyle)
                    } catch (e) {
                        console.error(e)
                    }
                    this.detail = {id, bgstyle, tabstyle, introstyle, title, register_mode, is_registered}
                    this.joinList = res[1]['data']['list'];
                    delete res[1]['data']['list']
                    if(this.signtype == 2) {
                        this.teamform = this.cf.teamform()
                    }

                    const valueMap = {};
                    const labelMap = {};

                    if (register_mode == 2 && is_registered && registered_info) {
                        if (registered_info.name) {
                            valueMap['name'] = registered_info.name;
                            valueMap['mv_name'] = registered_info.name;
                            labelMap[normalizeLabel('姓名')] = registered_info.name;
                        }
                        if (registered_info.mobile) {
                            valueMap['mobile'] = registered_info.mobile;
                            valueMap['mv_mobile'] = registered_info.mobile;
                            labelMap[normalizeLabel('手机')] = registered_info.mobile;
                        }
                        if (registered_info.register_type) {
                            valueMap['register_type'] = registered_info.register_type;
                            labelMap[normalizeLabel('组别')] = registered_info.register_type;
                        }

                        if (registered_info.registerinfos) {
                            try {
                                const mainRegFields = JSON.parse(registered_info.registerinfos);
                                if (Array.isArray(mainRegFields)) {
                                    mainRegFields.forEach(field => {
                                        if (field.key_name && field.value !== undefined && field.value !== null && field.value !== '') {
                                            valueMap[field.key_name] = field.value;
                                        }
                                        if (field.show_name && field.value !== undefined && field.value !== null && field.value !== '') {
                                            labelMap[normalizeLabel(field.show_name)] = field.value;
                                        }
                                    });
                                }
                            } catch (e) {
                                console.warn("Failed to parse main registerinfos:", e);
                            }
                        }
                    }

                    let regForm = [];
                    let hiddenFields = [];
                    if (res[1]['data']['registerform']) {
                        try {
                            regForm = JSON.parse(res[1]['data']['registerform']);
                            if (register_mode == 2 && is_registered && Array.isArray(regForm)) {
                                const hasGroups = regForm.length > 0 && regForm[0].attrs;
                                if (hasGroups) {
                                    regForm.forEach(group => {
                                        if (group.attrs) {
                                            let visibleAttrs = [];
                                            group.attrs.forEach(attr => {
                                                let matchedValue = valueMap[attr.key_name];
                                                if (matchedValue === undefined) {
                                                    const norm = normalizeLabel(attr.show_name);
                                                    matchedValue = labelMap[norm];
                                                }
                                                if (matchedValue === undefined) {
                                                    if (['name', 'mv_name'].includes(attr.key_name)) matchedValue = valueMap['name'];
                                                    else if (['mobile', 'mv_mobile'].includes(attr.key_name)) matchedValue = valueMap['mobile'];
                                                    else if (['register_type'].includes(attr.key_name)) matchedValue = valueMap['register_type'];
                                                }

                                                if (matchedValue !== undefined && matchedValue !== null && matchedValue !== '') {
                                                    attr.value = matchedValue;
                                                    hiddenFields.push(attr);
                                                } else {
                                                    visibleAttrs.push(attr);
                                                }
                                            });
                                            group.attrs = visibleAttrs;
                                        }
                                    });
                                    regForm = regForm.filter(group => group.attrs && group.attrs.length > 0);
                                } else {
                                    let visibleAttrs = [];
                                    regForm.forEach(attr => {
                                        let matchedValue = valueMap[attr.key_name];
                                        if (matchedValue === undefined) {
                                            const norm = normalizeLabel(attr.show_name);
                                            matchedValue = labelMap[norm];
                                        }
                                        if (matchedValue === undefined) {
                                            if (['name', 'mv_name'].includes(attr.key_name)) matchedValue = valueMap['name'];
                                            else if (['mobile', 'mv_mobile'].includes(attr.key_name)) matchedValue = valueMap['mobile'];
                                            else if (['register_type'].includes(attr.key_name)) matchedValue = valueMap['register_type'];
                                        }

                                        if (matchedValue !== undefined && matchedValue !== null && matchedValue !== '') {
                                            attr.value = matchedValue;
                                            hiddenFields.push(attr);
                                        } else {
                                            visibleAttrs.push(attr);
                                        }
                                    });
                                    regForm = visibleAttrs;
                                }
                            }
                        } catch (e) {
                            console.log(e)
                        }
                    }
                    this.hiddenFields = hiddenFields;
                    res[1]['data']['registerform'] = regForm;
                    this.itemDetail = res[1]['data']
                    this.$toast.clear();

                    // If register_mode == 2 and is_registered, and there are no fields to fill, auto-submit
                    if (register_mode == 2 && is_registered && (!Array.isArray(regForm) || regForm.length === 0)) {
                        this.$toast.loading({
                            message: "正在提交...",
                            duration: 0,
                            forbidClick: true
                        });
                        this.$api.sports.submitCompare({cpgid: this.item_sub_id, registerInfo: this.hiddenFields}).then((resSub) => {
                            this.$toast.clear();
                            if (+resSub.status === 200) {
                                if (this.item_sub_id == 2591 || this.item_sub_id == 2592 || this.item_sub_id == 2593 || this.item_sub_id == 2594 || this.item_sub_id == 2595) {
                                    this.$router.replace({ name: 'sportsQues', params: { acid: 972 } });
                                } else if (+this.itemDetail.type === 5) {
                                    this.$router.replace({ name: 'sportsQues', params: { acid: this.itemDetail.activity_id } });
                                } else {
                                    this.$router.replace({ name: 'sportsResult', params: this.$route.params });
                                }
                            } else {
                                this.$toast.fail(resSub.message || "参与失败");
                            }
                        }).catch(err => {
                            this.$toast.clear();
                            this.$toast.fail("请求失败，请稍后重试");
                        });
                    }
                })


            }
        },
        mounted() {
            this.init();
        }

    }
</script>
